import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import { useGetLiveDataQuery } from '../services/sensorDataApi';
import { useGetBackfillStatusQuery } from '../services/backfillApi';

/**
 * Owns the 30-second polling subscriptions for getLiveData and backfill-status.
 * Called from AppContent (always mounted), so useLocation always reflects the
 * current route and skip flips to true the moment the user navigates away from '/'.
 * DashboardPage itself no longer carries a pollingInterval for these two endpoints.
 */
export function useDashboardPolling() {
  const { pathname } = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);
  const onDashboard = pathname === '/';

  useGetLiveDataQuery({ timeWindow: 5 }, {
    skip: !user || !onDashboard,
    pollingInterval: 30000,
  });

  useGetBackfillStatusQuery(undefined, {
    skip: !user?.companyID || !user?.companyName || !onDashboard,
    pollingInterval: 30000,
  });
}
